import React, { useEffect } from "react";

const AboutUs = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
    <div>
      <div className="inline-flex flex-col mb-[30px]">
        <h2 className="text-3xl font-bold">Terms and Conditions of Use</h2>
        <span className="logo-bottom-line block h-px "> </span>
      </div>

      <div className="graph-dashboard bg-[#10151A] rounded-[15px] mb-[20px] p-[30px]">
        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Eligibility
          </h4>
          <p className="info-col text-justify">
            Access to the Portal is granted to authorized customers and users
            designated by Signia Aerospace. Unauthorized access is strictly
            prohibited.
          </p>
        </div>

        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            User Responsibilities
          </h4>
          <p className="info-col text-justify">
            Maintain the confidentiality of your login credentials. Use the
            Portal only for lawful purposes and in accordance with these Terms.
            Notify Signia Aerospace immediately of any unauthorized use or
            suspected breach of security.
          </p>
        </div>

        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Data Access and Confidentiality{" "}
          </h4>
          <p className="info-col text-justify">
            Information accessed via the Portal is confidential and proprietary
            to Signia Aerospace and/or its affiliates. You agree not to copy,
            distribute, or disclose any Portal data to third parties without
            written permission.
          </p>
        </div>
        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Permitted Use{" "}
          </h4>
          <p className="info-col text-justify">
            Users may use the Portal solely to view and manage their company’s
            account information, submit orders, check statuses, download
            documents, or communicate with Signia Aerospace.
          </p>
        </div>
        <div className="mb-[30px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-2 uppercase">
            Prohibited Activities{" "}
          </h4>
          <p>You agree not to:</p>
          <ul className="list-disc pl-5 mt-2">
            <li className="text-white info-col">
              - Attempt to gain unauthorized access to other accounts or
              systems.
            </li>
            <li className="text-white info-col">
              - Introduce malicious software or code.{" "}
            </li>
            <li className="text-white info-col">
              - Use the Portal to transmit unlawful, harmful, or offensive
              content.
            </li>
          </ul>
        </div>
        <div className="mb-[0px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[0px] sm:mb-2 uppercase">
            Termination of Access{" "}
          </h4>
          <p className="info-col text-justify">
            Signia Aerospace reserves the right to suspend or terminate access
            to the Portal at its discretion, including but not limited to
            violation of these Terms or suspected misuse.
          </p>
          <br />
          <br />
        </div>
        <div className="mb-[10px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[0px] sm:mb-2 uppercase">
            Availability and Modifications{" "}
          </h4>
          <p className="info-col text-justify">
            Signia Aerospace does not guarantee uninterrupted access to the
            Portal. Features may be modified, suspended, or discontinued at any
            time without notice.
          </p>
          <br />
          <br />
        </div>
        <div className="mb-[0px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[0px] sm:mb-2 uppercase">
            Limitation of Liability{" "}
          </h4>
          <p className="info-col text-justify">
            Signia Aerospace is not liable for any damages arising from use of
            the Portal, including but not limited to data loss, unauthorized
            access, or system outages.
          </p>
          <br />
          <br />
        </div>
        <div className="mb-[0px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[0px] sm:mb-2 uppercase">
            Privacy{" "}
          </h4>
          <p className="info-col text-justify">
            All personal data will be handled in accordance with Signia
            Aerospace’s Privacy Policy. By using the Portal, you consent to such
            handling.
          </p>
          <br />
          <br />
        </div>
        {/* <div className="mb-[0px]">
          <h4 className="text-[16px] 2xl:text-[18px] mb-[0px] sm:mb-2 uppercase">
            Governing Law{" "}
          </h4>
          <p className="info-col text-justify">
            These Terms shall be governed by the laws of the State of Alabama,
            without regard to conflict of laws principles. You acknowledge that you have read,
            understood, and agree to these Terms and Conditions.
          </p>
          <br />
          <br />
        </div> */}
      </div>
    </div>
  );
};

export default AboutUs;
